import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const AssignmentsWrapper = styled.div`
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgb(114, 82, 220);
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(12)} ${pxToRem(32)};
  background: rgba(114, 82, 220, 0.05);
`;

export const AssignmentsTitle = styled.h4`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 500;
  padding-top: ${pxToRem(20)};
  margin: 0;
`;

export const AssignmentsDescription = styled.p`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 400;
  padding-top: ${pxToRem(20)};
`;

export const AssignmentsLink = styled.a`
  display: block;
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(18)};
  font-weight: 500;
  text-decoration: none;
  padding-top: ${pxToRem(20)};
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${pxToRem(12)};
  padding-top: ${pxToRem(20)};
`;

export const AssignmentsFiles = styled.div`
  a {
    font-size: ${pxToRem(14)};
    text-decoration: none;
    margin-bottom: ${pxToRem(4)};

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${pxToRem(22)};
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: ${pxToRem(10)};
  margin-top: ${pxToRem(10)};
  align-items: flex-end;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${pxToRem(10)};
  padding: ${pxToRem(10)} 0;
  margin-bottom: ${pxToRem(20)};
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(16)};
`;

export const AssignmentContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`;
